"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import IQCLogo from "@/components/global/ui/IQCLogo";
import { CTAButton } from "@/shadcn/ui/button";
import { resolveLink } from "@/sanity/globals/CTA";
import { DEFAULT_LANGUAGE } from "@/sanity/globals/I18n";
import { PageCompetitorSchema } from "@/sanity/pages/PageCompetitorTemplate";

export default function CompetitorHeader({ data }: { data: PageCompetitorSchema }) {
  const language = data.settings?.language;
  const homeHref = resolveLink(
    language && language !== DEFAULT_LANGUAGE ? `/${language}` : "/",
    language || DEFAULT_LANGUAGE,
  );
  const [finalLink, setFinalLink] = useState("");

  useEffect(() => {
    if (homeHref) setFinalLink(homeHref);
  }, [homeHref]);

  return (
    <header className="relative z-50 w-full border-b border-black/10 bg-white">
      <div className="mx-auto flex w-[min(150rem,calc(100%-4rem))] items-center justify-between py-[1.25rem]">
        <Link href={finalLink} aria-label="IQ Capital" className="shrink-0">
          <IQCLogo fill="black" width="17rem" height="3.15rem" />
        </Link>
        {data.headerCTA && (
          <CTAButton
            data={data.headerCTA}
            className="w-fit [&_.button]:min-h-[5rem] [&_.button]:px-[2.25rem] [&_.button]:tracking-[-0.035rem]"
          />
        )}
      </div>
    </header>
  );
}
